module.exports = __webpack_public_path__ + "static/media/acms_workflow.e375c92d.svg";